// extracted by mini-css-extract-plugin
module.exports = {"overflowButton":"IconMenu_overflowButton__218iw","disabledItem":"IconMenu_disabledItem__30Wr0"};